import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'react-toolbox';

const MAX_DIMENSION = 1600;
const JPEG_QUALITY = 0.8;

const normalizeImages = (value) => {
  if (Array.isArray(value)) return value;
  if (value && value.image_data_url) return [value];
  return [];
};

// Resize to MAX_DIMENSION on the long edge, re-encode as JPEG to keep wkhtmltopdf reliable.
function resizeAndEncode(dataUrl, onDone) {
  const img = new Image();
  img.onload = () => {
    const { width, height } = img;
    const scale = Math.min(1, MAX_DIMENSION / Math.max(width, height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(width * scale);
    canvas.height = Math.round(height * scale);
    canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
    onDone(canvas.toDataURL('image/jpeg', JPEG_QUALITY));
  };
  // Fall back to the original data URL so the counter is always released.
  img.onerror = () => onDone(dataUrl);
  img.src = dataUrl;
}

class ProductTemplate extends React.Component {
  handleFileChange = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    if (this.props.onReadStart) this.props.onReadStart();

    const reader = new FileReader();
    reader.onload = () => {
      resizeAndEncode(reader.result, (encodedUrl) => {
        const images = normalizeImages(this.props.product_template);
        this.props.onChange([...images, {
          file_name: file.name,
          content_type: 'image/jpeg',
          image_data_url: encodedUrl,
        }]);
        if (this.props.onReadEnd) this.props.onReadEnd();
      });
    };
    reader.onerror = () => { if (this.props.onReadEnd) this.props.onReadEnd(); };
    reader.readAsDataURL(file);

    if (this.fileInput) {
      this.fileInput.value = '';
    }
  };

  removeImage = (index) => {
    const images = normalizeImages(this.props.product_template);
    this.props.onChange(images.filter((_, i) => i !== index));
  };

  render() {
    const images = normalizeImages(this.props.product_template);

    return (
      <div style={{ marginTop: '20px' }}>
        <h5>Product Template</h5>
        <h6>
          This section should be utilized if needed for highly configurable products, complex
          measurements, or specification of products.
        </h6>
        <input
          type="file"
          accept="image/*"
          onChange={this.handleFileChange}
          style={{ marginTop: '8px' }}
          ref={(input) => { this.fileInput = input; }}
        />
        {images.map((image, index) => (
          <div key={image.image_data_url} style={{ marginTop: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '8px' }}>{image.file_name || 'Image attached'}</span>
              <IconButton
                icon="close"
                onClick={() => this.removeImage(index)}
              />
            </div>
            <img
              src={image.image_data_url}
              alt="Product Template preview"
              style={{ maxWidth: '200px', maxHeight: '200px', marginTop: '4px' }}
            />
          </div>
        ))}
      </div>
    );
  }
}

ProductTemplate.propTypes = {
  product_template: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  onReadStart: PropTypes.func,
  onReadEnd: PropTypes.func,
};

export default ProductTemplate;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/ProductTemplate.jsx